/** User-facing copy for OTP send responses (keep in sync with backend wording). */

export function otpSendSuccessToast({ isEmail, data }) {
  if (data?.delivery_skipped) {
    return 'OTP ready — autofilled for verification';
  }
  if (!isEmail) {
    return (
      data?.message
      || `Verification code requested for ${data?.destination_masked || 'your mobile'}. Check your phone for the SMS.`
    );
  }
  return data?.message || 'OTP sent';
}

export function otpSendFailureToast({ isEmail, fallbackDetail }) {
  if (fallbackDetail) return fallbackDetail;
  return isEmail
    ? 'Failed to send OTP'
    : 'Failed to send SMS OTP. Please try email verification or contact support.';
}
